import { define } from 'wicked-elements'

define('[data-component~="select"]', {
  init () {
    this.value = false
    this.handleChange = this.handleChange.bind(this)
  },
  handleChange (e) {
    this.value = e.target.value
    if (!!this.value) {
      this.element.setAttribute('has-value', '')
    } else {
      this.element.removeAttribute('has-value')
    }
  },
  connected () {
    this.element.addEventListener('change', this.handleChange)
  },
  disconnected () {
    this.element.removeEventListener('change', this.handleChange)
  }
})